import { AnyAction } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import rootReducer from "./rootReducer";

export const setupStore = (preloadedState?: Partial<ReduxState>) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: {
          // Legacy Property and Comp requests keep Axios cancellation handles here.
          ignoredActions: [
            "SET_PROPERTY_CANCEL_TOKEN",
            "SET_COMP_CANCEL_TOKEN",
          ],
          ignoredPaths: [
            "PropertyReducer.cancelToken",
            "CompReducer.cancelToken",
          ],
        },
      }),
    preloadedState,
  });

const store = setupStore();

export type AppDispatch = typeof store.dispatch;
export type ReduxState = ReturnType<typeof rootReducer>;
export type TypedDispatch = ThunkDispatch<ReduxState, any, AnyAction>;
export type TypedThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  ReduxState,
  unknown,
  AnyAction
>;
export const useTypedDispatch = () => useDispatch<TypedDispatch>();

export default store;
